import i18n from '../i18n';

export const NumEmployees = [
  {
    value: '0-10',
    label: i18n.t('settings.business.options.fewer_than_11'),
  },
  {
    value: '11-50',
    label: '11-50',
  },
  {
    value: '51-250',
    label: '51-250',
  },
  {
    value: '251-1000',
    label: '251-1000',
  },
  {
    value: '1001+',
    label: i18n.t('settings.business.options.more_than_1000'),
  },
];

export const Roles = [
  {
    value: 'Business Owner',
    label: i18n.t('settings.business.options.business_owner'),
  },
  {
    value: 'Clerical/Office Staff',
    label: i18n.t('settings.business.options.office_staff'),
  },
  {
    value: 'Consultant',
    label: i18n.t('settings.business.options.consultant'),
  },
  {
    value: 'Engineer',
    label: i18n.t('settings.business.options.engineer'),
  },
  {
    value: 'Salesperson',
    label: i18n.t('settings.business.options.salesperson'),
  },
  {
    value: 'Marketer',
    label: i18n.t('settings.business.options.marketer'),
  },

  {
    value: 'Project Manager',
    label: i18n.t('settings.business.options.project_manager'),
  },
  {
    value: 'Proposal Writer',
    label: i18n.t('settings.business.options.proposal_writer'),
  },

  {
    value: 'Tradesperson',
    label: i18n.t('settings.business.options.tradesperson'),
  },
  {
    value: 'Other',
    label: i18n.t('settings.business.options.other'),
  },
];

export const minPasswordLength = 10;

export const maxPasswordLength = 72;

export default {
  NumEmployees,
  Roles,
};
